import { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faKeyboard } from '@fortawesome/free-solid-svg-icons'
import type { KbShortcut } from '../types'

interface KeyboardShortcutsProps {
    shortcuts: KbShortcut[]
}

const KeyboardShortcuts = ({ shortcuts }: KeyboardShortcutsProps) => {
    const shortcutCategories = Array.from(
        new Set(shortcuts.map((s) => s.category_label))
    )
    const [activeCategory, setActiveCategory] = useState<string>(
        shortcutCategories[0] || ''
    )

    const filtered = shortcuts.filter(
        (s) => s.category_label === activeCategory
    )

    return (
        <section className="kb-shortcuts">
            <div className="kb-shortcuts__header">
                <div className="kb-shortcuts__icon">
                    <FontAwesomeIcon icon={faKeyboard} />
                </div>
                <h2 className="kb-shortcuts__title">Keyboard Shortcuts</h2>
                <p className="kb-shortcuts__subtitle">
                    Work faster with these handy shortcuts
                </p>
            </div>

            <div className="kb-shortcuts__tabs">
                {shortcutCategories.map((cat) => (
                    <button
                        key={cat}
                        className={`kb-shortcuts__tab ${activeCategory === cat ? 'kb-shortcuts__tab--active' : ''}`}
                        onClick={() => setActiveCategory(cat)}
                    >
                        {cat}
                    </button>
                ))}
            </div>

            <div className="kb-shortcuts__grid">
                {filtered.map((shortcut, idx) => (
                    <div
                        key={shortcut.id}
                        className="kb-shortcut-item"
                        style={
                            { '--shortcut-index': idx } as React.CSSProperties
                        }
                    >
                        <div className="kb-shortcut-item__keys">
                            {shortcut.keys.map((key, ki) => (
                                <span key={ki}>
                                    <kbd className="kb-shortcut-item__key">
                                        {key === 'Ctrl'
                                            ? '⌘'
                                            : key === 'Shift'
                                              ? '⇧'
                                              : key === 'Tab'
                                                ? '⇥'
                                                : key === 'Enter'
                                                  ? '↵'
                                                  : key === 'Esc'
                                                    ? '⎋'
                                                    : key}
                                    </kbd>
                                    {ki < shortcut.keys.length - 1 && (
                                        <span className="kb-shortcut-item__plus">
                                            +
                                        </span>
                                    )}
                                </span>
                            ))}
                        </div>
                        <span className="kb-shortcut-item__desc">
                            {shortcut.description}
                        </span>
                    </div>
                ))}
            </div>
        </section>
    )
}

export default KeyboardShortcuts
